module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/032-zambia-c6029d946a7f31a07ab6ff14889d683d.svg";